
import type { RouteComponentProps } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import Merchant from "../pages/merchant/page";
import News from "../pages/news/page";
import Terms from "../pages/terms/page";
import ProductDetail from "../pages/product/[id]";
import CategoryPage from "../pages/category/[category]";

interface RouteConfig {
  path: string;
  component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
  exact?: boolean;
}

const routes: RouteConfig[] = [
  {
    path: "/",
    component: Home,
    exact: true,
  },
  {
    path: "/login",
    component: Login,
    exact: true,
  },
  {
    path: "/register",
    component: Register,
    exact: true,
  },
  {
    path: "/about",
    component: About,
    exact: true,
  },
  {
    path: "/contact",
    component: Contact,
    exact: true,
  },
  {
    path: "/merchant",
    component: Merchant,
    exact: true,
  },
  {
    path: "/news",
    component: News,
    exact: true,
  },
  {
    path: "/terms",
    component: Terms,
    exact: true,
  },
  {
    path: "/product/:id",
    component: ProductDetail,
    exact: true,
  },
  {
    path: "/category/:category",
    component: CategoryPage,
    exact: true,
  },
  {
    path: "*",
    component: NotFound,
  },
];

export default routes;
